import React from 'react'
import { useState } from 'react'
import ErrorLine from 'components/ErrorLine.js'
import { displayError } from 'util/screenUtils.js'
import Button from 'components/CustomButtons/Button.js'
import ListDND from 'components/dnd/ListDND'
import { listSongsAndVideo } from 'controllers/SocialServiceController'
import { CATEGORY_MODES } from 'redux/reducers/harmonizeReducer'
import { useEffect } from 'react'
import { updateSequences } from 'controllers/SocialServiceController'

export default function SequenceStudio() {
  const [error, setError] = useState()
  const [studioMessages, setStudioMessages] = useState([])

  const displayStudioSequence = () => {
    return (<div style={{ marginLeft: '2em', marginRight: '2em', paddingBottom: '3em' }}>
      <ErrorLine error={error} />
      {displayStudioMessages()}
    </div>
    )
  }

  const displayStudioMessage = (msg) => {
    const { messageId, sequence } = msg
    return (
      <div key={messageId} style={{ display: 'flex', justifyContent: 'space-between' }} >{sequence} {msg.name}
      </div>
    )
  }

  const displayStudioMessages = () => {
    return (
      <div >
        <hr />
        <p style={{ fontStyle: 'italic', fontSize: '0.75em', lineHeight: 'normal', textAlign: 'center' }}>Drag and drop to rearrange playlist. Click to set Playlist cover. Click trash can to remove from playlist.</p>
        <div style={{
          display: 'flex', overflowY: 'auto', height: '60vh',
          overscrollBehavior: 'contain'
        }}>
          <ListDND sourceList={studioMessages}
            updateList={(list) => setStudioMessages(list)}
            renderLine={displayStudioMessage} />
        </div>

        <Button
          color="primary"
          title='Update'
          style={{ marginRight: '2em', cursor: 'pointer' }}
          onClick={(evt) => {
            evt.stopPropagation()
            updateSequence()
          }}>
          Update
        </Button>
      </div>
    )

  }

  const updateSequence = async () => {
    setError()
    let maxSequence = studioMessages.length
    studioMessages.forEach(msg => msg.sequence = maxSequence--)
    setStudioMessages([...studioMessages])
    const bulkUpdate = []
    studioMessages.forEach(msg => {
      const { _id, sequence = 0 } = msg
      bulkUpdate.push({ messageId: _id, sequence })
    })
    console.log(`updateSequence results`, bulkUpdate)
    try {
      await updateSequences(bulkUpdate)
    } catch (error) {
      displayError(error, setError)
    }
  }

  useEffect(() => {
    listSongsAndVideo(CATEGORY_MODES.ALL_MEDIA, 0, 200).then(s => {
      setStudioMessages(s)
    }).catch(error => displayError(error, setError))
  }, [])

  return displayStudioSequence()

}
